import {
  createMoniIntegrationAsync,
  deleteMoniIntegrationAsync,
  getAllMoniIntegrationsAsync,
  getMoniIntegrationByIdAsync,
  updateMoniIntegrationAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateMoniIntegrationAsync = () =>
  useMutation(createMoniIntegrationAsync);

export const useGetMoniIntegrationByIdAsync = () =>
  useMutation(getMoniIntegrationByIdAsync);

export const useGetAllMoniIntegrationsAsync = () =>
  useMutation(getAllMoniIntegrationsAsync);

export const useUpdateMoniIntegrationAsync = () =>
  useMutation(updateMoniIntegrationAsync);

export const useDeleteMoniIntegrationAsync = () =>
  useMutation(deleteMoniIntegrationAsync);
